import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Plus, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export default function PropDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [days, setDays] = useState(1);
  const [qty, setQty] = useState(1);
  const { add } = useCart();

  useEffect(() => { api.get(`/props/${id}`).then((r) => setP(r.data)); }, [id]);

  if (!p) return <div className="pt-32 text-center">Loading…</div>;

  return (
    <div data-testid="prop-detail-page" className="pt-24">
      <section className="container mx-auto px-4 pt-12 pb-24">
        <Link to="/props" className="text-sm text-zinc-500 hover:text-[#FF007F]">← All props</Link>
        <div className="grid lg:grid-cols-2 gap-10 mt-6">
          <img src={p.image} alt={p.name} className="w-full aspect-square object-cover rounded-2xl bg-zinc-100" />
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-2">{p.category}</div>
            <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mb-4">{p.name}</h1>
            <p className="text-lg text-[#52525B] mb-6 leading-relaxed">{p.description}</p>
            <div className="font-display font-black text-4xl text-gradient mb-1">₹{p.daily_rate.toLocaleString()}<span className="text-base text-zinc-500 font-medium">/day</span></div>
            <div className="text-sm text-zinc-500 mb-8">+ ₹{p.deposit} refundable security deposit</div>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <label className="text-xs uppercase tracking-widest font-mono text-zinc-500">Quantity</label>
                <div className="flex items-center gap-3 mt-2">
                  <button onClick={() => setQty(Math.max(1, qty - 1))} className="w-8 h-8 rounded-full border border-zinc-300">−</button>
                  <span className="font-display font-bold text-xl w-8 text-center">{qty}</span>
                  <button onClick={() => setQty(qty + 1)} className="w-8 h-8 rounded-full border border-zinc-300">+</button>
                </div>
              </div>
              <div>
                <label className="text-xs uppercase tracking-widest font-mono text-zinc-500">Rental days</label>
                <div className="flex items-center gap-3 mt-2">
                  <button onClick={() => setDays(Math.max(1, days - 1))} className="w-8 h-8 rounded-full border border-zinc-300">−</button>
                  <span className="font-display font-bold text-xl w-8 text-center">{days}</span>
                  <button onClick={() => setDays(days + 1)} className="w-8 h-8 rounded-full border border-zinc-300">+</button>
                </div>
              </div>
            </div>

            <div className="bg-zinc-50 border border-zinc-200 rounded-2xl p-4 mb-6">
              <div className="flex justify-between text-sm mb-1"><span>Rental ({qty} × {days}d)</span><b>₹{(p.daily_rate * qty * days).toLocaleString()}</b></div>
              <div className="flex justify-between text-sm"><span>Deposit ({qty} ×)</span><b>₹{(p.deposit * qty).toLocaleString()}</b></div>
            </div>

            <button onClick={() => { add(p, days, qty); toast.success("Added to cart"); }}
              data-testid="prop-add-cart"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-brand text-white font-bold w-full justify-center">
              <Plus className="w-5 h-5" /> Add to cart
            </button>
            <Link to="/cart" className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[#FF007F]">
              View cart <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
